import React from "react";
import NavBar from "./NavBar";

export const TopNavBar = ({ ...rest }) => <NavBar {...rest} />;
